import { Auth } from '@aws-amplify/auth'

import store from '@/store/store'
import oauthSetup from '@/helpers/oauth-setup'

export function initAmplify () {
  Auth.configure({
    // Partner integration in oauth
    oauth: oauthSetup(store.getters['site/currentRootUrl'], store.getters['site/cognitoDomainURL']),
    // REQUIRED - Amazon Cognito Region
    region: 'eu-west-1',
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: store.getters['site/cognitoUserPoolId'],
    // OPTIONAL - Amazon Cognito Web Client ID
    userPoolWebClientId: store.getters['site/cognitoAppClientId'],
    // Required for the migration trigger to work
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    clientMetadata: {
      brand: store.getters['site/brand'],
      locale: store.getters['site/actualLocale']
    }
  })
}
